"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PATIENT_RESPONSE_EXAMPLE = void 0;
exports.PATIENT_RESPONSE_EXAMPLE = {
    uhidCounterType: 'OPD',
    id: '22222222-2222-2222-2222-222222222222',
    tenantId: '11111111-1111-1111-1111-111111111111',
    uhid: 'UHID000001',
    givenName: 'Asha',
    middleName: null,
    familyName: 'Rao',
    dateOfBirth: '1990-04-12',
    dateOfBirthPrecision: 'EXACT',
    genderId: null,
    maritalStatusId: null,
    bloodGroupId: null,
    religionId: null,
    nationalityId: null,
    salutationId: null,
    qualificationId: null,
    isNewborn: false,
    relationTypeId: null,
    relationName: null,
    registrationCompleteness: 'FULL',
    isUnknownIdentity: false,
    status: 'ACTIVE',
    dateOfDeath: null,
    primaryBranchId: null,
    mergedIntoPatientId: null,
    version: 1,
    lockVersion: 1,
    createdAt: '2026-07-10T09:00:00.000Z',
    updatedAt: '2026-07-10T09:00:00.000Z',
};
//# sourceMappingURL=registration.response.js.map